import React, {useContext, useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import $ from "jquery";
import Menu from "./menu/Menu";
import Header from "./header/Header";
import Catalogs from "./content/catalog/Catalogs";
import Categories from "./content/category/Categories";
import SubCategories from "./content/subcategory/SubCategories";
import Products from "./content/product/Products";
import Screen from "./content/screen/Screen";
import SellerGroups from "./content/sellergroup/SellerGroups";
import Sellers from "./content/seller/Sellers";
import Pricelists from "./content/pricelist/Pricelists";
import PaymentMethods from "./content/paymentmethod/PaymentMethods";
import NotFound from "./content/404/NotFound";
import Sale from "./content/sale/Sale";
import Closing from "./content/closing/Closing";
import Printer from "./content/printer/Printer";
import Display from "./content/display/Display";
import BarcodeReader from "./content/barcodereader/BarcodeReader";
import PaymentTerminal from "./content/paymentterminal/PaymentTerminal";
import AutomaticDrawer from "./content/automaticdrawer/AutomaticDrawer";
import ObjectSheet from "../sheet/ObjectSheet";
import AccountList from "../overbox/account/AccountList"
import ErrorMessage from "./error/Error";
import ValidMessage from "./valid/Valid";
import WarningMessage from "../warning/Warning";
import Statistics from "./content/analyze/Statistics";
import Clients from "./content/client/Clients";
import Dashboard from "./content/dashboard/Dashboard";
import Events from "../tools/event/Events";
import Popup from "../overbox/popup/Popup";
import FormPwd from "../form/account/FormPwd";
import ToDeployProcess from "../overbox/deployment/ToDeployProcess";
import ManualDrawer from "./content/manualdrawer/ManualDrawer";
import CatalogController from "../../stories/_catalog/Catalogs/CatalogController";
import PosScreenController from "../../stories/_setting/PosScreens/PosScreenController";
import Account from "../../stories/_account/Accounts/Account";
import BackgroundTaskController from "../../stories/_account/BackgroundTasks/BackgroundTaskController";
import SessionContext from "../../context/SessionContext";
import BackofficeContext from "../../context/BackofficeContext";
import "../../css/page/Content.css";

const BackOffice = props => {
    const { page } = props;
    const { handleCheckBigBisoux } = useContext(SessionContext);
    const [ boAccountsForm, setBoAccountsForm ] = useState(false);
    const [ informationForm, setInformationForm ] = useState(false);
    const [ settingForm, setSettingForm ] = useState(false);
    const [ accountForm, setAccountForm ] = useState(false);
    const [ passwordForm, setPasswordForm ] = useState(false);
    const [ bubbleText, setBubbleText ] = useState(null);
    const [ errorText, setErrorText ] = useState(null);
    const [ warningText, setWarningText ] = useState(null);
    const [ validText, setValidText ] = useState(null);
    const [ intervalTasks, setIntervalTasks ] = useState(null);
    const [ event, setEvent ] = useState(null);
    const [ objectPopup, setObjectPopup ] = useState(null);
    const [ getDatasPopup, setGetDatasPopup ] = useState(null);
    const [ statePopup, setStatePopup ] = useState(null);
    const [ subStatePopup, setSubStatePopup ] = useState(null);
    const [ popupLoadingIcon, setPopupLoadingIcon ] = useState(null);
    const [ popupLoadingText, setPopupLoadingText ] = useState(null);
    const [ backgroundTasks, setBackgroundTasks ] = useState(null);
    const [ typeDeployProcess, setTypeDeployProcess ] = useState(null);
    const env = JSON.parse(localStorage.getItem("env"));
    const params = useParams();

    const init = () => {
        handleCheckBigBisoux();

        getCatalog();
        getScreen();
        getTasks(true);
    }
    const goContent = () => {
        switch (page) {
            // dashboard
            case "dashboard": return <Dashboard />;

            // statistic
            case "analyze": return <Statistics type={ params.type !== undefined ? params.type : null } dateBegin={ params.dateBegin !== undefined ? params.dateBegin : null } dateEnd={ params.dateEnd !== undefined ? params.dateEnd : null } />;
            case "sales": return <Sale page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "closing": return <Closing page={ params.page !== undefined ? parseInt(params.page) : null } />

            // catalog
            case "catalogs": return <Catalogs page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "pricelists": return <Pricelists page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "categories": return <Categories page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "subcategories": return <SubCategories page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "products": return <Products page={ params.page !== undefined ? parseInt(params.page) : null } />

            // sellers
            case "sellergroups": return <SellerGroups page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "sellers": return <Sellers page={ params.page !== undefined ? parseInt(params.page) : null } />

            // clients
            case "clients": return <Clients page={ params.page !== undefined ? parseInt(params.page) : null } />

            // settings
            case "screens": return <Screen page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "paymentMethods": return <PaymentMethods page={ params.page !== undefined ? parseInt(params.page) : null } />

            // peripherals
            case "printers": return <Printer page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "displays": return <Display page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "barcodereaders": return <BarcodeReader page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "paymentterminals": return <PaymentTerminal page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "manualdrawers": return <ManualDrawer page={ params.page !== undefined ? parseInt(params.page) : null } />
            case "automaticdrawers": return <AutomaticDrawer page={ params.page !== undefined ? parseInt(params.page) : null } />

            // 404
            case "404": return <NotFound />

            default: return <p>{ page + " introuvable" }</p>
        }
    }
    const closeBoAccountsForm = () => {
        setBoAccountsForm(false)
    }
    const closeInformationForm = () => {
        setInformationForm(false)
    }
    const closeSettingForm = () => {
        setSettingForm(false)
    }
    const closeAccountForm = () => {
        setAccountForm(false)
    }
    const closePasswordForm = () => {
        setPasswordForm(false);
    }
    const bubbleHunter = () => {
        if (bubbleText === null) {
            window.removeEventListener('mousemove', moveBubble, false)
        }
        else {
            window.addEventListener('mousemove', moveBubble, false)
        }
    }
    const moveBubble = event => {
        let idBubbleItem = "#bubble"
        if ($(idBubbleItem).length === 0) return

        let posX = event.pageX
        let posY = event.pageY

        $(idBubbleItem).css({
            left: (posX + 10),
            top: (posY - 35),
        });
    }
    const getCatalog = () => {
        if (env.type === "store") return

        let controller = new CatalogController();
        controller._callback = returnGetCatalog;
        controller.index("", 0, 0, true);
    }
    const returnGetCatalog = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                localStorage.setItem("catalogs", JSON.stringify(list));

                if (list.length === 1)
                    localStorage.setItem("catalog", JSON.stringify(list[0]));
                else
                    localStorage.setItem("catalog", JSON.stringify({}));

                break;
            default: break;
        }
    }
    const getScreen = () => {
        if (env.type === "store") return

        let controller = new PosScreenController();
        controller._callback = returnGetScreen;
        controller.index();
    }
    const returnGetScreen = (list, error, status) => {
        switch (status) {
            case 200:
                localStorage.setItem("screens", JSON.stringify(list));
                break;
            default: break;
        }
    }
    const getTasks = (initInterval = false) => {
        const controller = new BackgroundTaskController();
        controller._callback = returnGetTasks;
        controller.index();

        if (initInterval) {
            let interNotification = setInterval(getTasks, 10000);
            setIntervalTasks(interNotification);
        }
    }
    const returnGetTasks = (list, error, status) => {
        switch (status) {
            case 200:
                setBackgroundTasks(list);
                break;
            default: break;
        }
    }

    useEffect(() => {
        init();
    }, []);
    useEffect(() => {
        return() => {
            clearInterval(intervalTasks);
        }
    }, [intervalTasks]);
    useEffect(() => {
        bubbleHunter();
    }, [bubbleText]);

    const valueBackofficeContext = {
        setBubbleText,
        setErrorText,
        setWarningText,
        setValidText,
        setEvent,
        objectPopup,
        setObjectPopup,
        getDatasPopup,
        setGetDatasPopup,
        statePopup,
        setStatePopup,
        subStatePopup,
        setSubStatePopup,
        popupLoadingIcon,
        setPopupLoadingIcon,
        popupLoadingText,
        setPopupLoadingText,
        backgroundTasks,
        setBackgroundTasks,
        typeDeployProcess,
        setTypeDeployProcess
    };

    return (
        <BackofficeContext.Provider value={valueBackofficeContext}>
            <div className="backoffice interfaceStore">
                <div id={"bubble"} className={"bubbleHover" + (bubbleText !== null ? " visible" : "")}><p>{ bubbleText }</p></div>
                {errorText !== null && <ErrorMessage message={errorText} />}
                {warningText !== null && <WarningMessage message={warningText} />}
                {validText !== null && <ValidMessage message={validText} />}
                {boAccountsForm && <AccountList handleClose={closeBoAccountsForm}/>}
                {informationForm && <ObjectSheet objectType="store" closeDisplay={closeInformationForm}/>}
                {settingForm && <ObjectSheet objectType="setting" withOverlayer={false} closeDisplay={closeSettingForm}/>}
                {accountForm && <ObjectSheet objectType="account" closeDisplay={closeAccountForm}/>}
                {passwordForm && <FormPwd object={ new Account(JSON.parse(localStorage.getItem("user"))) } closeView={ closePasswordForm } />}
                {typeDeployProcess !== null && <ToDeployProcess task={typeDeployProcess} />}
                <Menu page={page} />
                <Header setUserAccountForm={setAccountForm} setUserPasswordForm={setPasswordForm} setAccountsForm={setBoAccountsForm} setInformationForm={setInformationForm} setSettingForm={setSettingForm}/>
                {goContent()}
                <Popup />
                <Events event={ event } />
            </div>
        </BackofficeContext.Provider>
    )
}

export default BackOffice;
